import { useEffect, useRef, useState } from 'react';
import FilesGroupEdit from './FilesGroupEdit';
import WebUniversal, { WUExtendPropsType } from '../system/WebUniversalNewEx'
import { columnsheadId } from '../universal/columnshead';
import { Select, Space, Switch, Tooltip } from 'antd';
import fetchApi from '../../utils/api/fetchApi';
import getList from '../../utilsTsx/universal/getList';

const WebComponent = (props: any) => {

    const ref = useRef<any>(undefined);
    const apiId = 'filesGroup';

    /** 后端数据defaultService */
    const [defaultService, setDefaultService] = useState<string>('');
    const [InitData, setInitData] = useState<any>();
    const [filesServerData, setFilesServerData] = useState<any>();
    const [selectedServerId, setSelectedServerId] = useState<string | undefined>(undefined);
    const [serviceData, setServiceData] = useState<any>();
    const [selectedServiceId, setSelectedServiceId] = useState<string | undefined>(undefined);

    /**
     * 获取服务号数据
     * @param options 选项
     */
    const getServiceData = async (options: {
        /** 文件服务器id */
        filesServerId: string;
        /** 服务地址 */
        urlService?: string;
    }) => {
        const { filesServerId, urlService = defaultService } = options;
        fetchApi.GET(urlService,
            {
                apiId: 'filesService',
                apiExtend: 'showList',
                apiData: {
                    sendPageData: {
                        filesServerId
                    }
                }
            }).then(res => {
                if (res.success) {
                    setServiceData(res.data);
                }
            })
    };

    useEffect(() => {
        let urlService: string = '';
        if (ref.current) {
            urlService = ref.current.defaultService;
            setDefaultService(urlService);
            setInitData(() => ref.current.initData);
        }
        fetchApi.GET(urlService,
            {
                apiId: 'filesServer',
                apiExtend: 'showList'
            }).then(res => {
                if (res.success) {
                    setFilesServerData(res.data);
                    for (const item of res.data) {
                        const { id, isDefault, defaultServiceId } = item;
                        if (isDefault === true) {
                            setSelectedServerId(id);
                            setSelectedServiceId(defaultServiceId);
                            getServiceData({
                                filesServerId: id,
                                urlService
                            });
                            break;
                        }
                    }
                }
            })
    }, []);
    /**
     * 表头内容
     */
    const columnsHead = [
        {
            title: '组名',
            dataIndex: 'groupName',
        },
        {
            title: "服务号",
            dataIndex: 'service',
            render: (text: any) => (
                text
                    ? text.serviceName
                    : ''
            )
        },
        {
            title: '文件夹',
            dataIndex: 'folder',
        },
        {
            title: '日期目录',
            dataIndex: 'isCreateDateDirectory',
            render: (text: any, record: any) => (
                <Tooltip placement="topLeft" title={"是否每天生成日期子目录存放文件，" +
                    "如[是]刚不能自定义子目录?，" +
                    "如[否]可上传自定义子目录(上传带参数subdirectory)。"}>
                    <Switch checkedChildren="是" unCheckedChildren="否"
                        checked={text} key={record.id}
                    /></Tooltip>)
        }
    ];

    /**
     * 表头
     */
    const columns = columnsheadId
        .concat(columnsHead as []);

    /**
     * 扩展Props
     */
    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '文件组',
        apiId,
        columns,
        showStates: true,
        EditComponent: FilesGroupEdit,
    };

    return (
        <>
            <Space>
                <Select
                    showSearch
                    placeholder="服务器"
                    optionFilterProp="children"
                    value={selectedServerId}
                    onChange={async (e, option: any) => {
                        await getServiceData({
                            filesServerId: e
                        })
                        setSelectedServerId(e);
                        const { defaultServiceId } = option?.item;
                        setSelectedServiceId(defaultServiceId);
                        InitData({
                            apiId,
                            sendPageData: {
                                filesServerId: e,
                                serviceId: defaultServiceId
                            }
                        });
                    }}
                    style={{ width: 130 }}
                    filterOption={(input, option: any) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                    {getList.general(filesServerData, {
                        itemName: 'serverName'
                    })}
                </Select>
                <Select
                    showSearch
                    placeholder="服务号"
                    optionFilterProp="children"
                    value={selectedServiceId}
                    onChange={(e) => {
                        setSelectedServiceId(e);
                        InitData({
                            apiId,
                            sendPageData: {
                                filesServerId: selectedServerId,
                                serviceId: e
                            }
                        });
                    }}
                    style={{ width: 130 }}
                    filterOption={(input, option: any) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                    {getList.general(serviceData, {
                        itemName: 'serviceName'
                    })}
                </Select>
            </Space>
            <> </>
            <WebUniversal props={extendProps} ref={ref} />
        </>
    )
}

export default WebComponent;